module.exports = __webpack_public_path__ + "static/media/padlock.bbbddbbf.png";